import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';
import Curriculum from '../Curriculum';
import CampusIndex from './routes/CampusIndex';

const LazyStudentCampus = React.lazy(
	() => import(/* webpackChunkName: 'StudentCampus' */ './components')
);

export default () => {
	return {
		path: ':campusId',
		element: <AsyncLoading component={<LazyStudentCampus />} />,
		children: [CampusIndex(), Curriculum()],
	};
};
